import { render, staticRenderFns } from "./OrderInvoiceRecipientView.vue?vue&type=template&id=6f1c6f8a&scoped=true&"
import script from "./OrderInvoiceRecipientView.vue?vue&type=script&lang=js&"
export * from "./OrderInvoiceRecipientView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c6f8a",
  null
  
)

export default component.exports